export default function(form, name, classes = [], data = {}) {
	data.component = 'Form';
	data.form = name;
	data.fieldsGroup = name;
	return `<form ${this.html.classAttr(['form'].concat(classes))} ${this.html.dataAttr(data)}>`;
}
